import React, { useEffect } from 'react';

function LandingPageContent({
  onLogin,
  onRegister,
  onOpenOferta,
  onOpenPolicy,
  onOpenReferral,
  showReferral,
  onCloseReferral,
}) {
  useEffect(() => {
    const elements = document.querySelectorAll('.reveal');
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    elements.forEach((el) => observer.observe(el));

    const counters = document.querySelectorAll('.counter');
    const resultsSection = document.getElementById('results');
    let countersStarted = false;

    function animateCounter(el) {
      const target = Number(el.dataset.target || 0);
      const suffix = el.dataset.suffix || '';
      const duration = 1400;
      const startTime = performance.now();
      const tick = (now) => {
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = 1 - (1 - progress) * (1 - progress);
        el.textContent = `${Math.floor(target * eased)}${suffix}`;
        if (progress < 1) requestAnimationFrame(tick);
        else el.textContent = `${target}${suffix}`;
      };
      requestAnimationFrame(tick);
    }

    let counterObs;
    if (resultsSection) {
      counterObs = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !countersStarted) {
              counters.forEach(animateCounter);
              countersStarted = true;
              obs.unobserve(resultsSection);
            }
          });
        },
        { threshold: 0.3 }
      );
      counterObs.observe(resultsSection);
    }

    return () => {
      observer.disconnect();
      if (counterObs) counterObs.disconnect();
    };
  }, []);

  return (
    <>
      <div className="bg-layer bg-layer-top"></div>
      <div className="bg-layer bg-layer-bottom"></div>

      <header className="header" id="top">
        <div className="container header-row">
          <a className="brand brand-image" href="#top" aria-label="PulseADS">
            <span className="icon" role="img" aria-label="PulseADS"></span>
          </a>

          <nav className="nav" aria-label="Основная навигация">
            <a href="#hero">Главная</a>
            <a href="#features">Возможности</a>
            <a href="#pricing">Тарифы</a>
            <a href="https://t.me/leolegendaleo" target="_blank" rel="noopener noreferrer">Контакты</a>
          </nav>

          <div className="header-actions">
            <button type="button" className="btn btn-ghost" onClick={onLogin}>Войти</button>
            <button type="button" className="btn btn-primary" onClick={onRegister}>Попробовать бесплатно 3 дня</button>
          </div>
        </div>
      </header>

      <main>
        <section className="hero reveal" id="hero">
          <div className="container hero-grid">
            <div>
              <p className="eyebrow landing_text">PulseADS.ru</p>
              <h1 className="landing_h1">PulseADS - мощный инструмент для продвижения на Avito</h1>
              <p className="hero-lead landing_text">
                Экономьте время и деньги: автоматизация размещения, контроль балансов,
                уникализация объявлений и управление большими объемами без ручной рутины.
              </p>
              <div className="hero-actions">
                <button type="button" className="btn btn-primary" onClick={onRegister}>Попробовать бесплатно 3 дня</button>
                <a className="btn btn-light landing_link" href="#features">Смотреть возможности</a>
              </div>
              <ul className="hero-points">
                <li>Публикация по расписанию</li>
                <li>Массовые операции в пару кликов</li>
                <li>Поддержка и внедрение под ваш процесс</li>
              </ul>
            </div>

            <aside className="dashboard-mockup" aria-label="Мокап дашборда">
              <div className="mockup-head">
                <span></span><span></span><span></span>
              </div>
              <div className="mockup-body">
                <div className="mockup-card large">
                  <p className="landing_text">Объявлений активны</p>
                  <strong>750 000</strong>
                  <small>+14.2% за 30 дней</small>
                </div>
                <div className="mockup-card">
                  <p className="landing_text">Баланс аккаунтов</p>
                  <strong>4 324 640 ₽</strong>
                </div>
                <div className="mockup-card">
                  <p className="landing_text">Отложено публикаций</p>
                  <strong>39 920</strong>
                </div>
              </div>
            </aside>
          </div>
        </section>

        <section className="section reveal" id="features">
          <div className="container">
            <h2 className="landing_h2">Все ключевые инструменты продвижения в одном сервисе</h2>
            <p className="section-subtitle landing_text">6 преимуществ, которые дают вам скорость, масштаб и контроль.</p>

            <div className="features-grid">
              <article className="feature-card">
                <h3 className="landing_h3">Управление бесконечным числом аккаунтов</h3>
                <p className="landing_text">Подключайте и контролируйте любое количество кабинетов в едином интерфейсе.</p>
              </article>
              <article className="feature-card">
                <h3 className="landing_h3">Публикация по расписанию</h3>
                <p className="landing_text">Планируйте выход объявлений по времени, дням и сегментам аудитории.</p>
              </article>
              <article className="feature-card">
                <h3 className="landing_h3">Контроль баланса</h3>
                <p className="landing_text">Следите за расходами и пополняйте нужные аккаунты без потери кампаний.</p>
              </article>
              <article className="feature-card">
                <h3 className="landing_h3">Турбо-скорость</h3>
                <p className="landing_text">Операции, которые раньше занимали часы, теперь выполняются за минуты.</p>
              </article>
              <article className="feature-card">
                <h3 className="landing_h3">Массовое редактирование</h3>
                <p className="landing_text">Обновляйте цены, тексты и параметры сразу в тысячах объявлений.</p>
              </article>
              <article className="feature-card">
                <h3 className="landing_h3">Покрытие всей России до 50 000 объявлений на каждом Avito-аккаунте</h3>
                <p className="landing_text">Масштабируйте размещение на любые регионы и большие товарные матрицы: до 50 000 объявлений на каждый аккаунт.</p>
              </article>
            </div>
          </div>
        </section>

        <section className="section why reveal" id="why">
          <div className="container why-grid">
            <div>
              <h2 className="landing_h2">Почему стоит работать с PulseADS</h2>
              <p className="landing_text">
                Мы пришли в продукт из практики: 5 лет развиваем агентские процессы и 1.5 года
                строим сервис, который реально закрывает задачи предпринимателей, агентств и авитологов.
              </p>
              <p className="landing_text">
                Команда PulseADS помогает внедрить автоматизацию аккуратно: без сбоев,
                с прозрачными метриками и фокусом на рост продаж.
              </p>
            </div>
            <div className="why-visual">
              <div className="metrics-grid">
                <div className="metric-card">
                  <div className="metric-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" role="img">
                      <path d="M16 19v-1a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="9.5" cy="8" r="3" stroke="currentColor" strokeWidth="1.8"/>
                      <path d="M21 19v-1a3 3 0 0 0-2.2-2.9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                      <path d="M15.5 5.2a3 3 0 0 1 0 5.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                    </svg>
                  </div>
                  <div className="metric-value">100+</div>
                  <div className="metric-label">Активных пользователей</div>
                </div>
                <div className="metric-card">
                  <div className="metric-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" role="img">
                      <path d="M4 18h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                      <path d="M6 15.5l4-4 3 3 5-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M16.5 8.5H18V10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div className="metric-value">+54%</div>
                  <div className="metric-label">Прирост к продажам</div>
                </div>
                <div className="metric-card">
                  <div className="metric-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" role="img">
                      <rect x="3.5" y="6" width="17" height="12" rx="2.5" stroke="currentColor" strokeWidth="1.8"/>
                      <circle cx="12" cy="12" r="2.2" stroke="currentColor" strokeWidth="1.8"/>
                      <path d="M7.5 10h.01M16.5 14h.01" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
                    </svg>
                  </div>
                  <div className="metric-value">+30%</div>
                  <div className="metric-label">Экономия бюджета</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section reveal" id="pricing">
          <div className="container">
            <h2 className="landing_h2">Выберите тариф под ваш масштаб</h2>
            <p className="section-subtitle landing_text">Также вы можете конструировать тариф под свои задачи.</p>

            <div className="pricing-grid">
              <article className="price-card">
                <h3 className="landing_h3">Start</h3>
                <p className="price"><span className="price-value">990</span> ₽</p>
                <p className="price-note landing_text">/ 30 дней</p>
                <ul className="price-features">
                  <li>Управление до 5.000 объявлений на Авито</li>
                  <li>Лимит количества проектов - 3 шт.</li>
                  <li>Техподдержка робот</li>
                  <li>Нет полной техподдержки</li>
                </ul>
                <button type="button" className="btn btn-primary" onClick={onRegister}>Зарегистрироваться</button>
              </article>

              <article className="price-card">
                <h3 className="landing_h3">Lite</h3>
                <p className="price"><span className="price-value">1 800</span> ₽</p>
                <p className="price-note landing_text">/ 30 дней</p>
                <ul className="price-features">
                  <li>Управление до 5.000 объявлений на Авито</li>
                  <li>Лимит количества проектов - 10 шт.</li>
                  <li>Отображение баланса кошелька</li>
                  <li>Отображение расширенной статистики в Google</li>
                </ul>
                <button type="button" className="btn btn-primary" onClick={onRegister}>Зарегистрироваться</button>
              </article>

              <article className="price-card">
                <h3 className="landing_h3">Medium</h3>
                <p className="price"><span className="price-value">2 900</span> ₽</p>
                <p className="price-note landing_text">/ 30 дней</p>
                <ul className="price-features">
                  <li>Управление до 5.000 объявлений на Авито</li>
                  <li>Лимит количества проектов - 10 шт.</li>
                  <li>Отображение баланса кошелька</li>
                  <li>Отображение расширенной статистики в Google</li>
                  <li>Отображение главных метрик аккаунта Авито на графике проекта</li>
                </ul>
                <button type="button" className="btn btn-primary" onClick={onRegister}>Зарегистрироваться</button>
              </article>

              <article className="price-card highlight">
                <span className="badge">Максимум функций</span>
                <h3 className="landing_h3">Pro+</h3>
                <p className="price"><span className="price-value">4 890</span> ₽</p>
                <p className="price-note landing_text">/ 30 дней</p>
                <ul className="price-features">
                  <li>Управление до 50.000 объявлений на Авито</li>
                  <li>Лимит количества проектов - 10 шт.</li>
                  <li>Отображение баланса кошелька</li>
                  <li>Отображение расширенной статистики в Google</li>
                  <li>Отображение главных метрик аккаунта Авито на графике проекта</li>
                  <li>Управление ставками (цена просмотра) в Google Таблице</li>
                  <li>Генерация видео из фото (массово)</li>
                  <li>Уникализация фото (массово)</li>
                </ul>
                <button type="button" className="btn btn-primary" onClick={onRegister}>Зарегистрироваться</button>
              </article>
            </div>
          </div>
        </section>

        <section className="section reveal" id="results">
          <div className="container">
            <h2 className="landing_h2">Для кого PulseADS и каких результатов ждать</h2>

            <div className="results-grid">
              <article className="result-card">
                <strong className="counter" data-target="100" data-suffix="+">0</strong>
                <p className="landing_text">Пользователей уже работают в системе</p>
              </article>
              <article className="result-card">
                <strong className="counter" data-target="54" data-suffix="%">0</strong>
                <p className="landing_text">Средний прирост продаж после внедрения</p>
              </article>
              <article className="result-card">
                <strong className="counter" data-target="30" data-suffix="%">0</strong>
                <p className="landing_text">Экономия рекламного бюджета</p>
              </article>
            </div>

            <div className="audience-grid">
              <article className="audience-card">
                <h3 className="landing_h3">Предприниматели</h3>
                <p className="landing_text">Больше заявок без увеличения ручной нагрузки на команду.</p>
              </article>
              <article className="audience-card">
                <h3 className="landing_h3">Агентства</h3>
                <p className="landing_text">Единая система для ведения клиентских кабинетов и отчетности.</p>
              </article>
              <article className="audience-card">
                <h3 className="landing_h3">Авитологи-фрилансеры</h3>
                <p className="landing_text">Стабильные результаты и скорость работы, как у большой команды.</p>
              </article>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer" id="footer">
        <div className="container footer-row">
          <a className="brand brand-image totop" href="#hero" aria-label="PulseADS">
            <p>в начало ⬆</p>
          </a>
          <nav className="footer-links" aria-label="Полезные ссылки">
            <button type="button" className="footer-link-btn" onClick={onOpenOferta}>Оферта</button>
            <button type="button" className="footer-link-btn" onClick={onOpenPolicy}>Политика конфиденциальности</button>
            <button type="button" className="footer-link-btn" onClick={onOpenReferral}>Реферальная программа</button>
            <a className="landing_link" href="https://t.me/leolegendaleo" target="_blank" rel="noopener noreferrer">Telegram-поддержка</a>
          </nav>
        </div>
        <p className="copyright landing_text">© 2026 PulseADS.ru. Все права защищены.</p>
      </footer>

      {showReferral && (
        <div className="modal-overlay" onClick={onCloseReferral}>
          <div className="modal-window" onClick={(e) => e.stopPropagation()}>
            <h2 className="landing_h2">Реферальная программа</h2>
            <p className="landing_text"><b>Зарабатывайте вместе с PulseADS!</b></p>
            <p className="landing_text">Рекомендуйте наш сервис друзьям, коллегам и подписчикам - получайте <b>щедрое вознаграждение</b> за каждого приведенного клиента.</p>
            <ul>
              <li>Высокий процент от всех оплат ваших рефералов</li>
              <li>Пожизненные выплаты за активных пользователей</li>
              <li>Уникальная ссылка и личный кабинет для отслеживания дохода</li>
              <li>Поддержка и помощь на каждом этапе</li>
            </ul>
            <p className="landing_text">
              Узнайте подробности и получите свою реферальную ссылку - напишите нам в{' '}
              <a className="landing_link" href="https://t.me/leolegendaleo" target="_blank" rel="noopener noreferrer" style={{ color: '#FF6B35', fontWeight: 600 }}>
                Telegram
              </a>!
            </p>
            <button className="modal-close" onClick={onCloseReferral}>Закрыть</button>
          </div>
        </div>
      )}
    </>
  );
}

export default LandingPageContent;
